import * as AddProcessElement from "../actions/AddOrUpdateElement";
import * as FetchAgentGroupsActions from "../actions/FetchAgentGroups";
import * as FetchActions from "../actions/FetchProcess";
import * as ManualTriggerActions from "../actions/ManualTriggerActions";
import * as NewProcessActions from "../actions/NewProcess";
import * as NewProcessFromTemplateActions from "../actions/ProcessFromTemplate";
import * as RemoveProcessElement from "../actions/RemoveElement";
import * as SaveProcessActions from "../actions/SaveProcess";
import * as UpdateBpmnActions from "../actions/UpdateBpmn";
import * as UpdateDescriptionActions from "../actions/UpdateDescription";
import * as UpdateNameActions from "../actions/UpdateName";
import * as UpdateParameterActions from "../actions/UpdateParameter";
import * as UpdateTargetFrameworkActions from "../actions/UpdateTargetFramework";
import * as UpdateVersionActions from "../actions/UpdateVersion";
import * as UpdateCancellationDisabledActions from "../actions/UpdateCancellationDisabled";

import { IAction } from "../model/IAction";
import { ElementType, IManualTriggerParameter } from "../model/IProcessData";
import { ParameterEditorValue } from "../model/ParameterEditorValue";
import { Process } from "../model/Process";
import { UPDATE_PROCESS_DOCUMENTATION, UpdateProcessDocumentationAction } from "processEditor/actions/UpdateProcessDocumentation";
import { arrayMove } from "react-sortable-hoc";

/* eslint-disable no-case-declarations */

export function processReducer(state: Process = new Process(), action: IAction): Process {
    switch (action.type) {
        case FetchActions.RECEIVE_PROCESS:
            const receiveAction = action as FetchActions.IReceiveProcessAction;
            return new Process(receiveAction.processData);
        case NewProcessActions.NEW_PROCESS:
        case NewProcessFromTemplateActions.NEW_PROCESS_FROM_TEMPLATE:
            const newProcessAction = action as NewProcessActions.NewProcessAction;
            return new Process(newProcessAction.processData);
        case UpdateBpmnActions.UPDATE_BPMN:
            const updateBpmnAction = action as UpdateBpmnActions.UpdateBpmnAction;
            return Object.assign({}, state, { "bpmn": updateBpmnAction.updatedBpmn });
        case UpdateNameActions.UPDATE_NAME:
            const updateNameAction = action as UpdateNameActions.UpdateNameAction;
            return Object.assign({}, state, { "name": updateNameAction.updatedName });
        case UpdateVersionActions.UPDATE_MAJOR_VERSION:
            const updateMajorVersionAction = action as UpdateVersionActions.UpdateMajorVersionAction;
            return Object.assign({}, state, { "majorVersion": updateMajorVersionAction.version });
        case UpdateVersionActions.UPDATE_MINOR_VERSION:
            const updateMinorVersionAction = action as UpdateVersionActions.UpdateMinorVersionAction;
            return Object.assign({}, state, { "minorVersion": updateMinorVersionAction.version });
        case UpdateDescriptionActions.UPDATE_DESCRIPTION:
            const updateDescriptionAction = action as UpdateDescriptionActions.UpdateDescriptionAction;
            return Object.assign({}, state, { "description": updateDescriptionAction.updatedDescription });
        case UpdateTargetFrameworkActions.UPDATE_TARGET_FRAMEWORK:
            const updateTargetFrameworkAction = action as UpdateTargetFrameworkActions.UpdateTargetFrameworkAction;
            return Object.assign({}, state, { "targetFramework": updateTargetFrameworkAction.frameworkId });
        case UpdateCancellationDisabledActions.UPDATE_CANCELLATION_DISABLED:
            const updateCancellationDisabledAction = action as UpdateCancellationDisabledActions.UpdateCancellationDisabledAction;
            return Object.assign({}, state, { "cancellationDisabled": updateCancellationDisabledAction.updatedValue });

        case UpdateParameterActions.UPDATE_PARAMETER:
            const updateManualTriggerDefaultAction = action as UpdateParameterActions.UpdateParameterAction;
            const index = updateManualTriggerDefaultAction.key?.substring(updateManualTriggerDefaultAction.key.indexOf("-") + 1, updateManualTriggerDefaultAction.key.length);
            const updatedManualTriggerDefaultParameterList: IManualTriggerParameter[] = Object.assign([], state.manualTrigger);
            if (updatedManualTriggerDefaultParameterList[index as any] != null) {
                const newValue = updateManualTriggerDefaultAction.newValue as ParameterEditorValue;
                updatedManualTriggerDefaultParameterList[index as any].nonStringifiedDefaultValue = newValue as unknown as string;
                updatedManualTriggerDefaultParameterList[index as any].defaultValue = "\"" + newValue + "\"";
                return Object.assign({}, state, { "manualTrigger": updatedManualTriggerDefaultParameterList });
            } else {
                return state;
            }

        case ManualTriggerActions.ADD_MANUALTRIGGER_KEY:
            const manualTriggerParameterList: IManualTriggerParameter[] = Object.assign([], state.manualTrigger);
            manualTriggerParameterList.push({
                type: "System.String", inputType: "text", parameterType: "TextParameter", defaultValue: "",
                displayOption: "", conditionalDisplayProperty: "", conditionalDisplayValues: [],
                isInvalid: true, invalidString: "", name: "", isSecret: false
            });
            return Object.assign({}, state, { "manualTrigger": manualTriggerParameterList });

        case ManualTriggerActions.UPDATE_MANUALTRIGGER_KEY:
            const updateManualTriggerAction = action as ManualTriggerActions.UpdateManualTriggerAction;
            const updatedManualTriggerKeyParameterList: IManualTriggerParameter[] = Object.assign([], state.manualTrigger);
            updatedManualTriggerKeyParameterList[updateManualTriggerAction.index].name = updateManualTriggerAction.newKey;
            updatedManualTriggerKeyParameterList[updateManualTriggerAction.index].isInvalid = updateManualTriggerAction.isInvalid;
            updatedManualTriggerKeyParameterList[updateManualTriggerAction.index].invalidString = updateManualTriggerAction.validationError;
            return Object.assign({}, state, { "manualTrigger": updatedManualTriggerKeyParameterList });

        case ManualTriggerActions.UPDATE_MANUALTRIGGER_TYPE:
            const updateManualTriggerTypeAction = action as ManualTriggerActions.UpdateDefaultManualTriggerType;
            const updatedManualTriggerTypeParameterList: IManualTriggerParameter[] = Object.assign([], state.manualTrigger);
            updatedManualTriggerTypeParameterList[updateManualTriggerTypeAction.index].isSecret = updateManualTriggerTypeAction.checked;
            return Object.assign({}, state, { "manualTrigger": updatedManualTriggerTypeParameterList });

        case ManualTriggerActions.UPDATE_MANUALTRIGGER_DESCRIPTION:
            const updateManualTriggerDescriptionAction = action as ManualTriggerActions.UpdateDefaultManualTriggerDescription;
            const updatedManualTriggerDescriptionParameterList: IManualTriggerParameter[] = Object.assign([], state.manualTrigger);
            updatedManualTriggerDescriptionParameterList[updateManualTriggerDescriptionAction.index].description = updateManualTriggerDescriptionAction.description;
            return Object.assign({}, state, { "manualTrigger": updatedManualTriggerDescriptionParameterList });

        case ManualTriggerActions.REMOVE_MANUALTRIGGER_KEY:
            const removeManualTriggerAction = action as ManualTriggerActions.RemoveManualTriggerAction;
            const updatedRemoveManualTriggerParameterList: IManualTriggerParameter[] = Object.assign([], state.manualTrigger);
            updatedRemoveManualTriggerParameterList.splice(removeManualTriggerAction.index, 1);
            return Object.assign({}, state, { "manualTrigger": updatedRemoveManualTriggerParameterList });

        case ManualTriggerActions.USE_PROCESS_FOR_MONITORINGRULE_CHANGE:
            const processForMonitoringRuleChangeAction = action as ManualTriggerActions.ProcessForMonitoringRuleChangeAction;
            return Object.assign({}, state, {
                isForMonitoringRule: processForMonitoringRuleChangeAction.use,
                manualTrigger: processForMonitoringRuleChangeAction.use ? [] : state.manualTrigger
            } as Process);

        case ManualTriggerActions.REORDER_MANUALTRIGGER_PARAMS:
            const reorderManualTriggerParamsAction = action as ManualTriggerActions.ReorderManualTriggerParamsAction;
            const manualTriggerKeyParameterList: IManualTriggerParameter[] = Object.assign([], state.manualTrigger);
            const reorderedManualTriggerKeyParameterList = arrayMove(manualTriggerKeyParameterList, reorderManualTriggerParamsAction.oldIndex, reorderManualTriggerParamsAction.newIndex);
            return Object.assign({}, state, { "manualTrigger": reorderedManualTriggerKeyParameterList });

        case AddProcessElement.ADD_GLOBAL_ERROR_HANDLER:
            const addAlement = action as AddProcessElement.AddElementAction;
            if (addAlement.element.type === ElementType.GlobalErrorHandler) {
                return Object.assign({}, state, { "hasGlobalErrorHandler": true });
            }
            return state;

        case RemoveProcessElement.REMOVE_GLOBAL_ERROR_HANDLER:
            return Object.assign({}, state, { "hasGlobalErrorHandler": false });

        case SaveProcessActions.SAVE_AND_RUN_PROCESS: {
            const saveAndRunProcessAction = action as SaveProcessActions.SaveAndRunProcessAction;
            return Object.assign({}, state, { id: saveAndRunProcessAction.processId, uniqueIdentifier: saveAndRunProcessAction.uniqueIdentifier });
        }

        case SaveProcessActions.OPEN_RUN_ONCE_DIALOG: {
            const openRunOnceDialogAction = action as SaveProcessActions.OpenRunOnceAction;
            return Object.assign({}, state, { id: openRunOnceDialogAction.processId, uniqueIdentifier: openRunOnceDialogAction.uniqueIdentifier });
        }

        case FetchAgentGroupsActions.SET_DEFAULT_TARGET_FRAMEWORK: {
            const setDefaultTargetFrameworkAction = action as FetchAgentGroupsActions.ISetDefaultTargetFrameworkAction;
            return Object.assign({}, state, { targetFramework: setDefaultTargetFrameworkAction.targetFramework });
        }

        case SaveProcessActions.CLOSE_DEPENDENCY_CONSTRAINT_SAVE_MODAL: {
            const closeDependencyConstraintModalAction = action as SaveProcessActions.CloseDependencyConstraintModalAction;
            if (closeDependencyConstraintModalAction.ignoreWarning) {
                return Object.assign({}, state, { ignoreDependencyConflicts: true });
            }
            return state;
        }

        case UPDATE_PROCESS_DOCUMENTATION: {
            const updateProcessDocumentationAction = action as UpdateProcessDocumentationAction;
            return Object.assign({}, state, { documentationMarkdown: updateProcessDocumentationAction.documentation });
        }
        default:
            return state;
    }
}
